import React from 'react';
import c from 'classnames';
import DefinitionListRow from './DefinitionListRow';
import DefinitionListTerm from './DefinitionListTerm';
import DefinitionListDetails from './DefinitionListDetails';

import './style.scss';

interface Props extends React.ComponentProps<'dl'> {}

interface DefinitionListComponent extends React.FC<Props> {
  Row: typeof DefinitionListRow;
  Term: typeof DefinitionListTerm;
  Details: typeof DefinitionListDetails;
}

const DefinitionList: DefinitionListComponent = ({
  children,
  className,
  ...rest
}) => {
  const classes = c('mo-definition-list', className);

  return (
    <dl className={classes} {...rest}>
      {children}
    </dl>
  );
};

DefinitionList.Row = DefinitionListRow;
DefinitionList.Details = DefinitionListDetails;
DefinitionList.Term = DefinitionListTerm;

export default DefinitionList;
